import { IWorkflowConfig } from "./helpers/interfaces";

const configuration: IWorkflowConfig = {
  clientId: "e0a25059-3644-4cc8-bfc3-ff2e610e8124",
  driveId: "",
  title: "Private Inspection Portal",
  version: "1.0.0",
  applications: [
    {
      name: "graphApi",
      baseUrl: "https://graph.microsoft.com/v1.0",
      scopes: [
        "openid",
        "offline_access",
        "email",
        "profile"
       
      ],
    },
    {
        name: "privateProviderInspectionApi",
        baseUrl: "https://localhost:7143/api",
        scopes: [""]        
    },
    ],
    appGuid: "F13F19DC-8F34-4DDD-B4D0-3BCE5DDD1212",
    appName: "PrivateProviderInspection"
};

export const getConfig = () => {
    configuration.title = process.env.REACT_APP_APPSETTINGS_TITLE ?? "";
    configuration.driveId = process.env.REACT_APP_APPSETTINGS_DRIVEID ?? "";
    configuration.version = process.env.REACT_APP_VERSION ?? "";
    configuration.appGuid = process.env.REACT_APP_APPGUID ?? "";
    configuration.applications.filter(x => x.name === "privateProviderInspectionApi")[0].baseUrl = process.env.REACT_APP_API_BASEURL ?? "";
    return configuration;
};

export default getConfig;
